<template>
    <div>
        <div class="form-row mb-1">
            <div class="col-md-12 form-group">
                <template v-if="answer !== null">
                    <datepicker-accessible
                        :label-single="question.content"
                        :custom-id="'questions['+question.id+']'"
                        :name="'questions['+question.id+']'"
                        mode="date"
                        :use_pencil_checkbox="false"
                        :is_required="Boolean(question.is_required)"
                        :disable="disabled"
                        :value="answer"
                        :correct="isCorrect"
                        @input="updateAnswer"
                    ></datepicker-accessible>
                </template>

                <div v-if="correctAnswersPreview && correctAnswersPreview[question.id] !== undefined">
                    <span>{{$lang('Poprawna odpowiedź: ')}}</span>
                    <span class="text-success">{{correctAnswersPreview[question.id]}}</span>
                </div>

                <div v-if="errors['questions.'+question.id]" class="invalid-feedback d-block">
                    {{ errors['questions.'+question.id][0] }}
                </div>
            </div>
        </div>
        <template v-for="nestedQuestion in question.nestedQuestions">
            <component :is="'survey-'+nestedQuestion.questionTypeElementName"
                       v-if="answer === nestedQuestion.triggering_answer[0]"
                       v-bind="{question: nestedQuestion,
                           surveyAnswers: surveyAnswers,
                           correctAnswers: correctAnswers,
                           correctAnswersPreview: correctAnswersPreview,
                           disabled: disabled,
                           errors: errors,
                           old: old}">
            </component>
        </template>
    </div>
</template>

<script>
import datepickerAccessible from "../../datepicker-accessible";

export default {
    name: "survey-date",
    components: {datepickerAccessible},
    props: {
        question: { type: Object|Array, required: true},
        surveyAnswers: {type: Object|Array|null, required: true},
        correctAnswers: {type: Object|Array|null, required: true},
        correctAnswersPreview: {type: Object|Array|null, required: true},
        disabled: {type: Boolean, required: true},
        old: {type: Array|Object|null, required: true},
        errors: {type: Array|Object, required: true}
    },
    data() {
        return {
            answer: null,
        }
    },
    methods: {
        setAnswer() {
            this.answer = '';
            if (this.old) {
                if (this.old[this.question.id]) {
                    this.answer = this.old[this.question.id] ?? '';
                }
            }
            else if (this.surveyAnswers && this.surveyAnswers[this.question.id]) {
                this.surveyAnswers[this.question.id].forEach(surveyAnswer => {
                    this.answer = surveyAnswer.content ?? '';
                });
            }
            else if (this.question.default_answer) {
                this.answer = this.question.default_answer;
            }
        },
        updateAnswer(value) {
            this.answer = value;
        }
    },
    mounted() {
        this.setAnswer();
    },
    computed: {
        isCorrect() {
            if (this.correctAnswers && this.correctAnswers[this.question.id] !== undefined) {
                return this.correctAnswers[this.question.id];
            }
            return null;
        }
    }
}
</script>
